export default __webpack_public_path__ + "static/causa-global-hambre-17cd9e2f116e64efc62f48b666b8bcfc.png";